@if (isLoading) {
  <div class="main-nav" id="myMainNav"  [ngClass]="{'expanded': isExpanded}" >
    <div class="main-content" #myMainNav  [ngClass]="{'expanded': isExpanded}">
      <ul>
        @for (item of navData; track $index) {
          <app-menu-item
            [item]="item"
            [isExpanded]="isExpanded"
          ></app-menu-item>
        }
      </ul>
    </div>
  </div>
} @else {
  <div class="main-nav">
    <div class="main-content">
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="text-center">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </div>
}
